import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {SeguridadService} from '@servicios/Seguridad.service';

import {PreguntaComponent} from './pregunta/pregunta.component';
import { PlantillaPreguntaComponent } from './plantillapregunta/plantillapregunta.component';
import { PeriodoEvaluacionComponent } from './periodoevaluacion/periodoevaluacion.component';
import { PreparacionEvaluacionComponent } from './preparacionevaluacion/preparacionevaluacion.component';
import { AsignacionEvaluacionComponent } from './asignacionevaluacion/asignacionevaluacion.component';

const routes: Routes = [
    {path: '', redirectTo: 'colaborador', pathMatch: 'full'},
    {path: 'pregunta', component: PreguntaComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'plantilla', component: PlantillaPreguntaComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'periodoevaluacion', component: PeriodoEvaluacionComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'preparacionevaluacion', component: PreparacionEvaluacionComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
    {path: 'asignacionevaluacion', component: AsignacionEvaluacionComponent, data: {modulo: 'app'}, canActivate: [SeguridadService]},
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PlaneacionRoutingModule {}
